<template>
  <div class="card">
    <div class="table-responsive">
      <table class="table table-sm table-striped fs-lg" width="100%">
        <thead class="bg-teal text-white">
          <tr>
            <th>Classificação dos centro de custos</th>
            <th class="text-end">Valor Previsto</th>
            <th class="text-end">Valor Reformulado</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(centroCustoFilho, index) in centrosCustosFilhos.ccFilhos"
            :key="index"
          >
            <td
              :class="{
                'cursor-pointer text-teal': !centroCustoFilho.bloqueado,
              }"
              class="cursor-pointer text-teal"
              @click="$emit('showDetalhesCentroCustoFilho', centroCustoFilho)"
            >
              {{ centroCustoFilho.codCCustoFilho }} -
              {{ centroCustoFilho.nomeCCustoFilho }}
            </td>
            <td class="text-end">
              {{ moneyToCurrencyBr(centroCustoFilho.valorProposta) }}
            </td>
            <td class="text-end">
              {{ moneyToCurrencyBr(centroCustoFilho.valorReformulacao) }}
            </td>
            <td class="text-center">
              <router-link
                v-if="centroCustoFilho.possuiMeta"
                :to="`/metas?codCCustoPai=${codCCustoPai}`"
                class="btn btn-outline-secondary btn-sm me-2"
                title="Clique para ver as metas"
              >
                Metas
              </router-link>
              <router-link
                v-if="!centroCustoFilho.bloqueado"
                :to="`/preenchimento?codCCustoPai=${codCCustoPai}&codCCustoFilho=${centroCustoFilho.codCCustoFilho}`"
                class="btn btn-outline-primary btn-sm"
                title="Clique para ver os lançamentos das naturezas orçamentárias"
              >
                Orçamento
              </router-link>
            </td>
          </tr>
          <tr class="fw-bold">
            <td>Total</td>
            <td class="text-end">
              {{ moneyToCurrencyBr(centrosCustosFilhos.totais.valorProposta) }}
            </td>
            <td class="text-end">
              {{
                moneyToCurrencyBr(centrosCustosFilhos.totais.valorReformulado)
              }}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { moneyToCurrencyBr } from '@/utils/strings'

export default {
  name: 'ListCCFilhosResumo',

  props: {
    codCCustoPai: {
      type: String,
      required: true,
    },
    centrosCustosFilhos: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      moneyToCurrencyBr,
    }
  },
}
</script>

<style scoped>
th,
td {
  padding: 6px;
}

.btn {
  padding: 5px;
}
</style>
